import React from "react";
import Container from "./Container";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
    className?: string;
    title?: string;
    subTitle?: string;
}

const SubHeader: React.FC<Props> = ({ children, className = "", title, subTitle }) => {
    return (
        <div className={`bg-[#E3E4E9] ${className}`}>
            <Container>
                <div className="flex justify-between items-center py-[16px]">
                    <div>
                        <h3 className="text-[20px] font-semibold">{title}</h3>
                        <p className="text-[14px] text-gray-600">{subTitle}</p>
                    </div>
                    {children}
                </div>
            </Container>
        </div>
    );
};

export default SubHeader;
